import { render } from "./MoreInfoSection.vue?vue&type=template&id=3c0cff94&scoped=true"
import script from "./MoreInfoSection.vue?vue&type=script&lang=js"
export * from "./MoreInfoSection.vue?vue&type=script&lang=js"

import "./MoreInfoSection.vue?vue&type=style&index=0&id=3c0cff94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0cff94"]])

export default __exports__